import { Editable } from './editable.model';

export class FileDescriptor implements Editable {
    fileId: string;
    fileName: string;
    fileSize: string;
    creationDate: Date;
    __edited?: boolean;
}
